import classnames from 'classnames'

import { TRevenueCriteriaThresholds } from '../models'

import styles from './RevenueCriteria.module.scss'

export interface IRevenueCriteriaProps {
  thresholds: TRevenueCriteriaThresholds
}

export const RevenueCriteria = ({ thresholds }: IRevenueCriteriaProps) => {
  return (
    <table className={styles.container}>
      <thead>
        <tr>
          <th className={classnames(styles.columnName, styles.cell, styles.cellHeader)}>
            {thresholds.group}
          </th>
          <th className={classnames(styles.cell, styles.cellHeader)}>Threshold</th>
        </tr>
      </thead>
      <tbody>
        {Object.values(thresholds.items).map(({ name, threshold }, index) => {
          return (
            <tr key={`value_${name}_${index}`}>
              <td className={classnames(styles.columnName, styles.cell, styles.cellValue)}>
                {name}
              </td>
              <td className={classnames(styles.cell, styles.cellValue)}>
                {`$ ${new Intl.NumberFormat().format(threshold)}`}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
